<div class="content-box" *ngIf="!isNoData">
  <div class="d-flex flex-auto justify-content-end filter" *ngIf="!isExportingPdfReport">
    <achoo-filter-box [options]="industryList"
                      name="industry"
                      placeholder="{{'measure.industries' | translate}}"
                      [(model)]="industryIndex"
                      (selectEvent)="selectIndustry(industryIndex)">
    </achoo-filter-box>
  </div>
  <div class="d-flex flex-row flex-auto benchmark-setting-summarize" *ngIf="benchmarkData.menu">
    <div class="d-flex justify-content-start flex-auto menu-name-left">
      {{benchmarkData.menu.nameLeft}}
    </div>
    <div class="d-flex justify-content-end menu-name-right">
      {{benchmarkData.menu.nameRight}}
    </div>
  </div>
  <div class="d-flex flex-row flex-auto benchmark-content"
    *ngFor="let item of benchmarkData.posts">
    <div class="left-side">
      <div class="left-summarize">
        <span *ngIf="!isImpactType(item.name)" class="percent">{{item.specificReach | formatNumberToString}}</span>
        <span *ngIf="isImpactType(item.name)" class="percent">{{item.specificReach | percentNumberSuffix}}</span>
        <p class="subtitle" [ngClass]="{'engagement': item.name === 'engagement'}">{{item.name}}</p>
      </div>
    </div>
    <div class="chart-content text-center">
      <div *ngIf="isAscending(item.status)" class="percent-comparison {{item.status}}">+{{item.percentComparison | percentNumberSuffix}}</div>
      <div *ngIf="!isAscending(item.status)" class="percent-comparison {{item.status}}">{{item.percentComparison | percentNumberSuffix}}</div>
      <div class="progress-bar-content">
        <div
          class="percent-progress-bar {{item.status}}" [ngStyle]="{'background-color': chartColorByStatus(item)}"
          [style.width.%]="calculatePercent(item.percentComparison, item.status)"
          [style.left.%]="leftPercent">
        </div>
      </div>
    </div>
    <div class="right-side text-right">
      <div class="right-summarize">
        <span *ngIf="!isImpactType(item.name)" class="percent">{{item.benchmarkReach | formatNumberToString}}</span>
        <span *ngIf="isImpactType(item.name)" class="percent">{{item.benchmarkReach | percentNumberSuffix}}</span>
        <p class="subtitle" [ngClass]="{'engagement': item.name === 'engagement'}">{{item.name}}</p>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="isNoData"
  class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/average-benchmark-performance-report/average-benchmark-performance-report.component.html